// extracted by mini-css-extract-plugin
export var badge = "_vb-4";
export var selected = "_vb-1";
export var selectedOverlay = "_vb-5";
export var thumbnailButton = "_vb-0";
export var thumbnailFallback = "_vb-3";
export var thumbnailImage = "_vb-2";